module.exports = __webpack_public_path__ + "static/media/administration.5a2c0005.svg";